<template>
  <sameday-form-handler :style="style" :form="form" v-slot="{ data, methods }">
    <div class="p-6 bg-color flex flex-col space-y-10">
      <sameday-form-header
        :form="form"
        :control="data.control"
        @on:back="$emit('on:back')"
      ></sameday-form-header>
      <component
        :form="form"
        :is="data.component"
        :control="data.control"
        :input="data.input"
        :errors="data.errors"
        @on:field="methods.onField"
        @on:step="methods.onStep"
        @on:error="methods.onError"
        @on:again="methods.onAgain"
        @on:reset="methods.onAgain"
        @on:scroll="$emit('scroll-to', $event)"
        @on:nextstep="$emit('on:nextstep', $event)"
        @onbookerror="$emit('onbookerror', $event)"
        @on:ocr_scan="$emit('on:ocr_scan', $event)"
        @on:submitted="$emit('on:submitted', $event)"
        @on:book_success="$emit('on:book_success', $event)"
      ></component>
    </div>
  </sameday-form-handler>
</template>

<script>
import SamedayFormHandler from "@/components/Sameday/SamedayFormHandler.vue";
import SamedayFormStep1 from "@/components/Sameday/SamedayFormStep1.vue";
import SamedayFormStep2 from "@/components/Sameday/SamedayFormStep2.vue";
import SamedayFormHeader from "@/components/Sameday/SamedayFormHeader.vue";

export default {
  components: {
    SamedayFormHandler,
    SamedayFormHeader,
    SamedayFormStep1,
    SamedayFormStep2,
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
    search: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    style() {
      return {
        "--bg-color":
          this.$store.state.config.colors.containerBackground || "#FFFFFF",
      };
    },
  },
};
</script>

<style scoped>
.bg-color {
  background-color: var(--bg-color);
}
</style>
